<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"></loading>
    <b-form @submit.stop.prevent="guardar">
      <div >
        <b-tabs class="mr-3 ml-3">
          <b-tab class="p-0">
            <template #title>
              Datos del Cupón
              <em class="admiracion" variant="danger" v-show="tab1Vacio" ></em>
            </template>

            <div class="scrollPorTabs mt-1">
              <b-row class="mb-2">
                <b-col>
                  <p style="color: var(--color-dentalia); font-weight: 600" class="mt-2">Datos generales</p>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12" md="4" lg="3">
                  <b-form-group align="left">
                    <label class="letter">Motivo del Cupón <validacion/> </label>
                    <b-input-group size="sm" >
                      <v-select
                          class="redondeo"
                          style="width: 100%; font-size: 12px"
                          label="descripcion"
                          id="motivo"
                          :options="opcionesMotivoCuponFiltro"
                          :reduce="(val) => val.idMotivoCupon"
                          v-model="$v.objGuardar.idMotivoCupon.$model"
                          placeholder="Selecciona el motivo del cupón"
                          :filterable="false"
                          @search="filtroOpcionesMotivoCupon"
                          @input="esConpensacion($event)"
                          :clearable="false"
                          :disabled="objGuardar.idCupon !== null"
                      ></v-select>
                      <validacion
                          v-if="$v.objGuardar.idMotivoCupon.$dirty && ($v.objGuardar.idMotivoCupon.$invalid || $v.objGuardar.idMotivoCupon.$error == 'true')"
                          texto="Selecciona el motivo del cupón"/>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="4" lg="3">
                  <b-form-group align="left">
                    <label class="letter" >Tipo Cupón <validacion/> </label>
                    <b-input-group size="sm">
                      <v-select
                          class="redondeo"
                          style="width: 100%;"
                          label="descripcion"
                          id="tipoCupon"
                          :options="opcionesTipoCuponFiltro"
                          :reduce="(val) => val.idTipoCupon"
                          v-model="$v.objGuardar.idTipoCupon.$model"
                          placeholder="Selecciona un tipo de cupón"
                          :filterable="false"
                          @search="filtroOpcionesTipoCupon"
                          @input="objGuardar.numeroRedenciones = 1"
                          :clearable="false"
                          :disabled="siEsCompensacion"
                      ></v-select>
                      <validacion
                          v-if="$v.objGuardar.idTipoCupon.$dirty && ($v.objGuardar.idTipoCupon.$invalid || $v.objGuardar.idTipoCupon.$error == 'true')"
                          texto="Selecciona el tipo de cupón"/>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col v-if="datosCita != undefined && datosCita != null"
                       cols="6" class="d-flex align-items-center">
                  <p class="m-0 font-weight-bold" style="color: var(--color-dentalia);">Paciente: {{ datosCita.nombrePaciente }} ({{ datosCita.idPaciente }})</p>

                  <b-button class="button-dentalia-svg-3 ml-3" variant="primary"
                            @click="eliminarPaciente()"
                            v-b-popover.hover.topright="'Quitar paciente'"
                  >
                    <em class="close_x_svg icon-dentalia-svg-3" style="height: 10px"></em>
                  </b-button>

                  <b-button class="button-dentalia-svg-1" variant="primary"
                            v-b-popover.hover.topright="'Mostrar/Ocultar búsqueda'"
                            v-if="
                            (idPaciente === undefined || idPaciente === null)"
                            @click="reabrirBusquedaPaciente"
                  >
                    <em class="lupa_svg icon-dentalia-svg-1"></em>
                  </b-button>
                </b-col>
                <b-col cols="12" md="6" :offset-md="datosCita!=null ? 3:0" style="padding: 15px">
                  <b-row :style="datosCita!=null?'width: 100%;':'width: 100%;'">
                    <b-col cols="12" style="display: flex">
                      <div
                          class="w-100"
                           v-if="mostrarBarraBusqueda" >
                        <div class="contenedorTablaSinColor" style="margin-top: 10px;" :style="datosCita != undefined && datosCita != null ? 'margin-left:0px; margin-rigth:0px;':''" v-if="objGuardar.idTipoCupon === 2">
                          <div style="display: flex;" >

                            <b-form-input
                                class="input-filter"
                                responsive
                                v-model="nombrePacienteBusqueda"
                                placeholder="Búsqueda de paciente por nombre o ID"
                                type="text"
                                @keydown.enter.prevent="buscarPacientes()"
                            ></b-form-input>

                            <b-button size="sm"
                                      variant="info"
                                      :disabled="loadingPacientes || validarInputBusqueda()"
                                      style="margin: auto;"
                                      class="mr-3"
                                      @click="buscarPacientes()">
                              <span v-if="!loadingPacientes"><em class="buscar_svg" style="height: 16px;"></em></span>
                              <span v-else><b-spinner small></b-spinner></span>
                            </b-button>

                          </div>
                        </div>
                        <validacion style="font-size: 10px;text-align: center;display: block;"
                                    v-if="validarInputBusqueda()"
                                    texto="No se pueden buscar letras y numeros al mismo tiempo" />
                      </div>
                      <b-button-group style="display: flex; margin: auto;" class="ml-2">





                      </b-button-group>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row v-if="objGuardar.idTipoCupon === 2 && registros !== null && mostrarBarraBusqueda">
                <b-col cols="12">

                  <div class="detalle-formulario-titulo">
                    <span>Pacientes encontrados</span>
                  </div>

                  <div align="center" v-if="loadingPacientes">
                    <b-spinner variant="primary" label="Spinning"></b-spinner>
                  </div>


                  <div class="overflow-auto"  v-if="!loadingPacientes">
                    <b-table
                        :items="registros"
                        :fields="columnasPacientesEncontrados"
                        :hover="true"
                        :small="true"
                        responsive
                        fixed
                        show-empty
                        class="contenedorTablaSinColor"
                        @row-clicked="seleccionarPaciente"
                        :per-page="registrosPorPagina"
                        :current-page="currentPage"
                    >

                      <template v-slot:cell(fechaUltimaCita)="row">
                        {{ row.item.fechaUltimaCita | formatoFechaHora }}
                      </template>
                      <template #cell(idTipoPaciente)="row">
                        <b-button v-b-tooltip.hover.left.bottom.v-light
                                  :title="'Paciente ' + row.item.tipoPaciente"
                                  variant="ligth" size="sm" pill>
                          <b-icon font-scale="2" icon="circle-fill"
                                  :style="'color: '+row.item.color +'; border:solid 1px gray; border-radius: 50%;cursor:pointer ' "
                          ></b-icon>
                        </b-button>
                      </template>
                      <template #empty="scope">
                        <b-alert show variant="warning">No hay datos</b-alert>
                      </template>
                    </b-table>

                  </div>

                </b-col>
                <div class="mt-2 w-100 flex justify-content-center align-items-end">
                  <b-pagination
                      align="center"
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="registrosPorPagina"
                  ></b-pagination>
                </div>
              </b-row>


              <b-row cols="1" cols-md="2" cols-lg="4" class="mr-3">
                <b-col>
                  <b-form-group align="left">
                    <label class="letter">Código <validacion/> </label>
                    <b-input-group size="sm">
                      <b-form-input
                          class="redondeo"
                          id="idNombreCorto"
                          placeholder="Ingresa el código"
                          :state="validateState('codigo')"
                          v-model="$v.objGuardar.codigo.$model"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col v-if="objGuardar.idMotivoCupon !== 2">
                  <b-form-group align="left">
                    <label class="letter">Descripción del cupón <validacion/> </label>
                    <b-input-group size="sm">
                      <b-form-input
                          class="redondeo"
                          id="descripcion"
                          placeholder="Ingresa la descripción del cupón"
                          :state="validateState('descripcion')"
                          v-model="$v.objGuardar.descripcion.$model"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>



                <b-col>
                  <b-form-group align="left">
                    <label class="letter">Tipo de Descuento <validacion/> </label>
                    <b-input-group size="sm">
                      <v-select
                          class="redondeo"
                          style="width: 100%;"
                          label="descripcion"
                          id="tipoDescuento"
                          :options="opcionesTipoDescuentoFiltro"
                          :reduce="(val) => val.idTipoDescuentoCupon"
                          v-model="$v.objGuardar.idTipoDescuentoCupon.$model"
                          placeholder="Selecciona un tipo de descuento"
                          :filterable="false"
                          @search="filtroOpcionesTipoDescuento"
                          :clearable="false"
                      ></v-select>
                      <validacion
                          v-if="$v.objGuardar.idTipoDescuentoCupon.$dirty && ($v.objGuardar.idTipoDescuentoCupon.$invalid || $v.objGuardar.idTipoDescuentoCupon.$error == 'true')"
                          texto="Selecciona el tipo de descuento"/>
                    </b-input-group>
                  </b-form-group>
                </b-col>


                <b-col>
                  <b-form-group align="left">
                    <label class="letter">Cantidad Descuento <validacion/> </label>
                    <b-input-group size="sm">
                      <b-form-input
                          class="redondeo"
                          id="idNombreCorto"
                          placeholder="Ingresa la cantidad del descuento"
                          :state="validateState('cantidadDescuento') &&
                                  ((objGuardar.idTipoDescuentoCupon === 1 && (objGuardar.cantidadDescuento > 0 && objGuardar.cantidadDescuento <= 99))
                                   || objGuardar.idTipoDescuentoCupon === 2)"
                          @keypress="onlyNumber($event)"
                          v-model.number="$v.objGuardar.cantidadDescuento.$model"
                          type="number"
                          :min="1"
                          :max="objGuardar.idTipoDescuentoCupon === 1 ? 99 : ''"
                          pattern="^[0-9]+"
                          onpaste="return false"
                          @input="cantidadMinMax($event)"
                      ></b-form-input>
                    </b-input-group>
                    <validacion
                        v-if="objGuardar.cantidadDescuento !== null &&
                        objGuardar.idTipoDescuentoCupon === 1 &&
                        !(objGuardar.cantidadDescuento > 0 && objGuardar.cantidadDescuento <= 99)"
                        texto="El porcentaje debe ser de 1 a 99"/>
                  </b-form-group>
                </b-col>

                <b-col>
                  <b-form-group align="left">
                    <label class="letter">Tipo Aplicación <validacion/> </label>
                    <b-input-group size="sm" >
                      <v-select
                          class="redondeo"
                          style="width: 100%;"
                          label="descripcion"
                          id="tipoAplicacion"
                          :options="opcionesTipoAplicacionFiltro"
                          :reduce="(val) => val.idTipoAplicacion"
                          v-model="$v.objGuardar.idTipoAplicacion.$model"
                          placeholder="Selecciona un tipo de aplicación"
                          :filterable="false"
                          @input="tipoDeAplicacion($event)"
                          @search="filtroOpcionesTipoAplicacion"
                          :clearable="false"
                      ></v-select>
                      <validacion
                          v-if="$v.objGuardar.idTipoAplicacion.$dirty && ($v.objGuardar.idTipoAplicacion.$invalid || $v.objGuardar.idTipoAplicacion.$error == 'true')"
                          texto="Selecciona el tipo de aplicación"/>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col v-if="objGuardar.idMotivoCupon !== 2">
                  <b-form-group align="left">
                    <label class="letter">Número de redenciones <validacion/> </label>
                    <b-input-group size="sm">
                      <b-form-input
                          class="redondeo"
                          id="idNombreCorto"
                          placeholder="Ingresa el número de redenciones"
                          :state="validateState('numeroRedenciones')"
                          @keypress="onlyNumber($event)"
                          v-model="$v.objGuardar.numeroRedenciones.$model"
                          type="number"
                          min="1" pattern="^[0-9]+"
                          :disabled="objGuardar.idTipoCupon === 2 && objGuardar.idMotivoCupon === 2"
                          onpaste="return false"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>



                <b-col>
                  <b-form-group align="left">
                    <label class="letter">Fecha de expedición <validacion/> </label>
                    <p class="letter" v-if="objGuardar.idCupon !== null"> {{  objGuardar.fechaExpedicion  | formatoFechaCorta  }} </p>
                    <p class="letter" v-else> {{  fechaMinima  | formatoFechaCorta  }} </p>
<!--                    <b-form-datepicker v-model="$v.objGuardar.fechaExpedicion.$model" :state="validateState('fechaExpedicion')"
                                       :min="new Date()" placeholder="Fecha de expedición"></b-form-datepicker>-->
                  </b-form-group>
                </b-col>

                <b-col>
                  <b-form-group align="left">
                    <label class="letter">Fecha de expiración <validacion/>
                    </label>
                    <b-form-datepicker v-model="$v.objGuardar.fechaExpiracion.$model" :state="validateState('fechaExpiracion') || (modificarFechaExpiracion ? false : null)"
                                       :min="new Date()" placeholder="Fecha de expiración"></b-form-datepicker>
                  </b-form-group>
                </b-col>

                <b-col v-if="objGuardar.idMotivoCupon === 2">
                  <div class="justify-content d-flex mt-5"  >
                    <span class="letter">¿Enviar por correo al paciente?</span>
                    <b-form-checkbox
                        v-model="objGuardar.enviarCorreo"
                        class="ml-3"
                        :disabled="objGuardar.idCupon !== null"
                    />
                  </div>
                </b-col>


              </b-row>

              <div v-if="objGuardar.idMotivoCupon === 2 && objGuardar.enviarCorreo && objGuardar.idCupon === null"
                   class="justify-content-center"
                   align="center">
                  <span class="letter" style="color: #FEA246">
                  Lo que escribas en la descripción será enviado al paciente, por favor verifica que sea claro y fácil de entender
                </span>
              </div>

              <div v-if="objGuardar.idMotivoCupon === 2"
                   style="min-width: 50%; max-width: 90%;overflow: auto;"
                   ref="descripcionDiv"
                   :style="{ width: anchoDescripcion }">
                <b-form-group align="left">
                  <label class="letter">Descripción del cupón <validacion/> </label>
                  <b-input-group size="sm">
                    <b-form-textarea
                        ref="textarea"
                        class="redondeo"
                        id="descripcion"
                        placeholder="Ingresa la descripción del cupón"
                        :state="validateState('descripcion')"
                        v-model="$v.objGuardar.descripcion.$model"
                        @input="ajustarAncho"
                    ></b-form-textarea>
                  </b-input-group>
                </b-form-group>
              </div>

              <div v-if="datosCita !== undefined && datosCita != null
                            && objGuardar.idMotivoCupon === 2
                             && datosCita.idPaciente !== null
                             && objGuardar.enviarCorreo
                             && objGuardar.idCupon === null"
              >
                <span class="letter mt-2" style="color: #62B6C2; font-weight: 500 ">Correo del paciente</span>
                <p class="letter mt-2" v-if="datosCita.correo === null">
                  El paciente “{{datosCita.nombrePaciente}}” no tiene un correo electrónico asociado. Por favor agregue uno
                </p>
                <p class="letter mt-2" v-else>
                  El paciente “{{datosCita.nombrePaciente}}” ya cuenta con datos de contacto, por favor verifica la información si es necesario
                </p>
              </div>

              <b-row v-if="datosCita !== undefined && datosCita != null
                            && objGuardar.idMotivoCupon === 2
                             && datosCita.idPaciente !== null
                             && objGuardar.enviarCorreo "
              >
                <b-col cols="col-sm-6 col-md-4 col-lg-4 mt-1" >
                  <b-input-group class="email-input">
                    <b-input-group-prepend is-text>
                      <b-icon icon="at" class="text-muted"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input placeholder="correo@ejemplo.com"
                                  v-model="objGuardar.correo"
                                  :state=" $emailState(this.objGuardar.correo)"
                                  :disabled="objGuardar.idCupon !== null"
                    ></b-form-input>
                  </b-input-group>
                </b-col>
              </b-row>


              <b-row class="mt-4" v-if="objGuardar.idMotivoCupon !== 2 && objGuardar.idMotivoCupon !== null && objGuardar.idTipoCupon !== 2">
                <b-col cols="12">
                  <p style="color: var(--color-dentalia); font-weight: 600" class="mt-2">Atributos del paciente</p>
                </b-col>

                <b-col cols="12" md="6" lg="3">
                  <b-form-group align="left">
                    <label class="letter">Tipo de Paciente <validacion/>
                    </label>
                    <b-input-group size="sm">
                      <v-select
                          class="redondeo"
                          style="width: 100%;"
                          label="descripcion"
                          id="subTipoPaciente"
                          :options="opcionesSubTipoPacienteFiltro"
                          :reduce="(val) => val.idSubTipoPaciente"
                          v-model="$v.objGuardar.idSubTipoPaciente.$model"
                          placeholder="Selecciona un tipo de paciente"
                          :filterable="false"
                          @search="filtroOpcionesSubTipoPaciente"
                          :clearable="false"
                          :state="validateState('idSubTipoPaciente')"
                      ></v-select>
                      <validacion
                          v-if="$v.objGuardar.idSubTipoPaciente.$dirty && ($v.objGuardar.idSubTipoPaciente.$invalid || $v.objGuardar.idSubTipoPaciente.$error == 'true')"
                          texto="Selecciona el tipo de paciente"/>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="6" lg="3">
                  <b-form-group align="left">
                    <label class="letter">SubTipo Paciente <validacion/> </label>
                    <b-input-group size="sm">
                      <v-select
                          class="redondeo"
                          style="width: 100%;"
                          label="descripcion"
                          id="tipoPaciente"
                          :options="opcionesTipoPacienteFiltro"
                          :reduce="(val) => val.idTipoPaciente"
                          v-model="$v.objGuardar.idTipoPaciente.$model"
                          placeholder="Selecciona un subtipo de paciente"
                          :filterable="false"
                          @search="filtroOpcionesTipoPaciente"
                          :clearable="false"
                          :state="validateState('idTipoPaciente')"
                      ></v-select>
                      <validacion
                          v-if="$v.objGuardar.idTipoPaciente.$dirty && ($v.objGuardar.idTipoPaciente.$invalid || $v.objGuardar.idTipoPaciente.$error == 'true')"
                          texto="Selecciona el subtipo de paciente"/>
                    </b-input-group>
                  </b-form-group>
                </b-col>


              </b-row>



              <b-row  class="mt-4" v-if="objGuardar.idMotivoCupon !== 2 && objGuardar.idMotivoCupon !== 1 && objGuardar.idMotivoCupon !== null">
                <b-col cols="12">
                  <p style="color: var(--color-dentalia); font-weight: 600" class="mt-2">Restricciones de compra</p>
                </b-col>

                <b-col>
                    <b-form-group align="left">
                      <label class="letter">Rango min. y máx. de compra  <validacion/>  </label>
                      <b-input-group size="sm">
                        <b-form-input
                            class="redondeo mr-3"
                            id="minCompra"
                            :state="validateState('minCompra')"
                            @keypress="onlyNumber($event)"
                            v-model.number="$v.objGuardar.minCompra.$model"
                            type="number"
                            :min="cantidadMinCompra"
                            pattern="^[0-9]+"
                            :disabled="objGuardar.idMotivoCupon === 2"
                            onpaste="return false"
                        ></b-form-input>
                        <b-form-input
                            class="redondeo mr-3"
                            id="maxCompra"
                            :state="validateState('maxCompra')"
                            @keypress="onlyNumber($event)"
                            v-model.number="$v.objGuardar.maxCompra.$model"
                            type="number"
                            pattern="^[0-9]+"
                            :disabled="objGuardar.idMotivoCupon === 2"
                            onpaste="return false"
                            :min="cantidadMinCompra"
                        ></b-form-input>
                      </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group align="left">
                    <label class="letter">Esquema de pago <validacion/> </label>
                    <b-input-group size="sm">
                      <v-select
                          class="redondeo"
                          style="width: 100%;"
                          label="nombreEsquema"
                          id="idEsquemaPagoCupon"
                          :min="bloquearEsquemaPago ? 0 : 1"
                          :options="opcionesEsquemaPagoCuponFiltro"
                          :reduce="(val) => val.idEsquemaPagoCupon"
                          v-model="objGuardar.idEsquemaPagoCupon"
                          placeholder="Selecciona un esquema de pago"
                          :filterable="false"
                          @search="filtroOpcionesEsquemaPagoCupon"
                          :disabled= "objGuardar.idMotivoCupon === 2 || bloquearEsquemaPago"
                          :clearable="false"
                      ></v-select>
                      <validacion
                          v-if="objGuardar.idTipoAplicacion === 1 && objGuardar.idEsquemaPagoCupon === null && this.objGuardar.idMotivoCupon !== 2"
                          texto="Selecciona un esquema de pago"/>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col v-if="opcionesFormaPago.length > 0">
                  <label class="letter">Forma de pago <validacion/> </label>
                  <SelectFormasPago
                      :formasPago="objGuardar.idsFormasPago"
                      :catalogoFormasPago="opcionesFormaPago"
                      :catalogoFinancieras="opcionesFinancieras">
                  </SelectFormasPago>
                  <validacion
                      v-if="objGuardar.idMotivoCupon !== null && objGuardar.idMotivoCupon !== 2 && objGuardar.idsFormasPago.length < 1"
                      texto="Selecciona la forma de pago"/>
                </b-col>
              </b-row>
              <div class="mt-2 col-md-12"></div>

            </div>
            <div class="text-center" v-if="objGuardar.idTipoAplicacion === 1 || objGuardar.idTipoAplicacion === null">
              <b-button
                  :disabled="objGuardar.enviarCorreo && objGuardar.correo === null"
                  class="mt-3 mr-4 botonesAzulFuerte"
                  variant="primary"
                  style="margin:10px"
                  @click="$refs.submitGuardar.click()">Guardar
              </b-button>

              <b-button
                  class="mt-3 ml-4 botonesGrisFuerte"
                  style="margin:10px"
                  @click="() => {$emit('cancelar')}">Cancelar
              </b-button>
            </div>
          </b-tab>
          <b-tab class="p-0" v-if="objGuardar.idTipoAplicacion === 2">
            <template #title>
              Cupón Tratamiento
              <em class="admiracion" variant="danger" v-show="tab2Vacio" ></em>
            </template>

            <b-row>
              <b-col>
                <p style="color: #17a2b8; font-weight: 600" class="mt-2">Datos del cupón tratamiento</p>
              </b-col>
            </b-row>

            <div class="scrollPorTabs mt-2">

              <formularioTratamientos
                  ref="formularioTratamientos"
                  :tratamientosOriginal="objGuardar.tratamientos"
                  :idTipoDescuento="objGuardar.idTipoDescuentoCupon"
                  :cantidadDescuento="objGuardar.cantidadDescuento"/>

            </div>
            <div class="text-center"  v-if="objGuardar.idTipoAplicacion === 2">
              <b-button
                  class="mt-3 botonesAzulFuerte"
                  variant="primary"
                  style="margin:10px"
                  @click="$refs.submitGuardar.click()">Guardar</b-button>

              <b-button
                  class="mt-3 botonesGrisFuerte"
                  style="margin:10px"
                  @click="() => {$emit('cancelar')}">Cancelar
              </b-button>
            </div>

          </b-tab>
        </b-tabs>
      </div>

      <b-button v-show="false" id="submitGuardar" ref="submitGuardar" type="submit" style="visibility: hidden"></b-button>
    </b-form>
  </div>
</template>

<script>
import "vue-datetime/dist/vue-datetime.css";
import {validationMixin} from "vuelidate";
import {required, maxLength, minValue, minLength} from "vuelidate/lib/validators";
import formularioTratamientos from "@/views/cupones/formularioTratamientos.vue";
import SelectFormasPago from "@/views/cupones/SelectFormasPago.vue";
import miniToastr from "mini-toastr";
import {DatosCita} from "@/components/NuevaAgenda/nuevaCita/DatosCita";
import Swal from "sweetalert2";

export default {

  name: "altaCupones",

  components: {
    formularioTratamientos,
    SelectFormasPago
  },

  props:{
    idPaciente: Number,
    mostrarGuardar: Boolean,
    cuponOriginal: {
      type: Object,
    },
    modificarFechaExpiracion: {
      type: Boolean,
      default: false
    }
  },

  mixins: [validationMixin],

  data(){
    return {
      anchoDescripcion: '50%',
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      loading: false,
      mostrarModal: false,

      opcionesTipoCupon:[],
      opcionesTipoCuponFiltro:[],
      opcionesMotivoCupon: [],
      opcionesMotivoCuponFiltro:[],
      opcionesTipoDescuento:[],
      opcionesTipoDescuentoFiltro:[],
      opcionesTipoAplicacion:[],
      opcionesTipoAplicacionFiltro:[],
      opcionesTipoEstatusCupon:[],
      opcionesTipoEstatusCuponFiltro:[],

      opcionesTipoPaciente:[],
      opcionesTipoPacienteFiltro:[],
      opcionesSubTipoPaciente:[],
      opcionesSubTipoPacienteFiltro:[],

      opcionesEsquemaPagoCupon:[],
      opcionesEsquemaPagoCuponFiltro:[],
      opcionesFormaPago:[],
      opcionesMeses:[],
      opcionesMesesFiltro:[],

      opcionesFinancieras:[],


      objGuardar: {
        idCupon: null,
        idTipoCupon: null,
        codigo: null,
        descripcion: null,
        idMotivoCupon: null,
        idTipoDescuentoCupon: null,
        idTipoAplicacion: null,
        cantidadDescuento: null,
        numeroRedenciones: null,
        otraPromo: false,
        fechaExpedicion: null,
        fechaExpiracion: null,
        idEstatusCupon: 1,

        idTipoPaciente: null,
        idSubTipoPaciente: null,


        minCompra:0,
        maxCompra:0,
        idEsquemaPagoCupon:null,
        idFormaPago:null,
        idsMsi: [],
        idsFormasPago: [],
        idPaciente: null,
        nombrePaciente: null,

        tratamientos: [],
        correo: null,
        enviarCorreo: false,
      },

      tab1Vacio: false,
      tab2Vacio: false,
      bloquearEsquemaPago:false,

      loadingPacientes: false,
      mostrarBarraBusqueda: true,
      nombrePacienteBusqueda: null,
      datosCita: null,
      registros: null,
      mostrarAdvertencia: false,



      columnasPacientesEncontrados: [
        {key: "id", label: "Id paciente", sortable: true},
        {key: "nombre", label: "Nombre paciente", sortable: true},
        {key: "estatusPTI", label: "PTI", sortable: true},
        {key: "fechaUltimaCita", label: "Fecha última cita", sortable: true},
        {key: "idTipoPaciente", label: "Tipo paciente", sortable: true},
      ],
      currentPage: 1,
      registrosPorPagina:10,
      cantidadMinCompra: 1,
      siEsCompensacion: false
    };
  },
  validations() {
    if (this.objGuardar.idMotivoCupon === null) {
      return {
        objGuardar: {
          idTipoCupon: {required, maxLength: maxLength(5)},
          codigo:{required, maxLength: maxLength(45)},
          descripcion: {required, maxLength: maxLength(100)},
          idMotivoCupon: {required, maxLength: maxLength(5)},
          idTipoDescuentoCupon: {required, maxLength: maxLength(5)},
          idTipoAplicacion:{required, maxLength: maxLength(5)},
          cantidadDescuento: {required, maxLength: maxLength(5)},
          fechaExpiracion: {required},
          numeroRedenciones: {required},
        }
      };
    } else if (this.objGuardar.idMotivoCupon === 2) {
      return {
        objGuardar: {
          idTipoCupon: {required, maxLength: maxLength(5)},
          codigo:{required, maxLength: maxLength(45)},
          descripcion: {required, minLength: minLength(3)},
          idMotivoCupon: {required, maxLength: maxLength(5)},
          idTipoDescuentoCupon: {required, maxLength: maxLength(5)},
          idTipoAplicacion:{required, maxLength: maxLength(5)},
          cantidadDescuento: {required, maxLength: maxLength(5)},
          fechaExpiracion: {required},
        }
      };
    } else if (this.objGuardar.idMotivoCupon === 2 && this.objGuardar.idTipoCupon === 2) {
      return {
        objGuardar: {
          idTipoCupon: {required, maxLength: maxLength(5)},
          codigo:{required, maxLength: maxLength(45)},
          descripcion: {required, maxLength: maxLength(100)},
          idMotivoCupon: {required, maxLength: maxLength(5)},
          idTipoDescuentoCupon: {required, maxLength: maxLength(5)},
          idTipoAplicacion:{required, maxLength: maxLength(5)},
          cantidadDescuento: {required, maxLength: maxLength(5)},
          fechaExpiracion: {required},
        }
      };
    } else if ((this.objGuardar.idMotivoCupon === 3 && this.objGuardar.idTipoCupon === 1) || (this.objGuardar.idMotivoCupon === 3 && this.objGuardar.idTipoCupon === null)) {
      return {
        objGuardar: {
          idTipoCupon: {required, maxLength: maxLength(5)},
          codigo:{required, maxLength: maxLength(45)},
          descripcion: {required, maxLength: maxLength(100)},
          idMotivoCupon: {required, maxLength: maxLength(5)},
          idTipoDescuentoCupon: {required, maxLength: maxLength(5)},
          idTipoAplicacion:{required, maxLength: maxLength(5)},
          cantidadDescuento: {required, maxLength: maxLength(5)},
          fechaExpiracion: {required},
          numeroRedenciones: {required},
          idTipoPaciente: {required},
          idSubTipoPaciente: {required},
          minCompra: {required, minValue: minValue(this.cantidadMinCompra)},
          maxCompra: {required, minValue: minValue(this.cantidadMinCompra)}
        }
      };
    } else if (this.objGuardar.idMotivoCupon === 3 && this.objGuardar.idTipoCupon === 2) {
      return {
        objGuardar: {
          idTipoCupon: {required, maxLength: maxLength(5)},
          codigo:{required, maxLength: maxLength(45)},
          descripcion: {required, maxLength: maxLength(100)},
          idMotivoCupon: {required, maxLength: maxLength(5)},
          idTipoDescuentoCupon: {required, maxLength: maxLength(5)},
          idTipoAplicacion:{required, maxLength: maxLength(5)},
          cantidadDescuento: {required, maxLength: maxLength(5)},
          fechaExpiracion: {required},
          numeroRedenciones: {required},
          minCompra: {required, minValue: minValue(this.cantidadMinCompra)},
          maxCompra: {required, minValue: minValue(this.cantidadMinCompra)}
        }
      };
    } else if (this.objGuardar.idMotivoCupon === 1) {
      return {
        objGuardar: {
          idTipoCupon: {required, maxLength: maxLength(5)},
          codigo:{required, maxLength: maxLength(45)},
          descripcion: {required, maxLength: maxLength(100)},
          idMotivoCupon: {required, maxLength: maxLength(5)},
          idTipoDescuentoCupon: {required, maxLength: maxLength(5)},
          idTipoAplicacion:{required, maxLength: maxLength(5)},
          cantidadDescuento: {required, maxLength: maxLength(5)},
          fechaExpiracion: {required},
          numeroRedenciones: {required},
          idTipoPaciente: {required},
          idSubTipoPaciente: {required},
        }
      };
    }
  },



  created() {
    this.debug = this.$localStorageService.getDebug();

    if(this.cuponOriginal.idCupon !== 0){
      this.obtenerDetalleCupon();
    }

    this.cargarCatalogos();
    this.$nextTick(() => {
      this.$v.$reset()
    });
  },
  watch: {
    "objGuardar.idTipoCupon": function (val){
      if(val === 1 && this.objGuardar.idMotivoCupon === 3){
        this.datosCita = null
        this.registros = null;
        this.nombrePacienteBusqueda = null;
        this.mostrarBarraBusqueda = true
      } else if (val === 2) {
        this.objGuardar.idTipoPaciente = null;
        this.objGuardar.idSubTipoPaciente = null;
      } else if(val === 1 && this.objGuardar.idMotivoCupon === 1){
        this.objGuardar.idTipoPaciente = null;
        this.objGuardar.idSubTipoPaciente = null;
      }
    }
  },
  computed: {
    fechaMinima: function () {
      const now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    },
    rows() {
      return this.registros.length;
    },
  },
  methods: {
    obtenerDetalleCupon() {
      this.loading = true;
      let detalleCupon = {};
      this.$http.post(this.$api + "cupon/obtenerDetalleCupon",this.cuponOriginal).then((response) => {
          detalleCupon = response.data.data;
      }).finally(() => {
        if (!this.mostrarGuardar) {
          this.objGuardar = JSON.parse(JSON.stringify(detalleCupon));
          if (this.objGuardar.idTipoAplicacion === 2) {
            this.bloquearEsquemaPago = true
          }

          if (this.objGuardar.idPaciente !== null) {
            this.datosCita = new DatosCita();
            this.datosCita.idPaciente = this.objGuardar.idPaciente;
            this.datosCita.nombrePaciente = this.objGuardar.nombrePaciente;
            this.mostrarBarraBusqueda = false;
          }
          this.esConpensacion(this.objGuardar.idMotivoCupon);
        }
        this.loading = false;
      });
    },

    ajustarAncho() {
      this.$nextTick(() => {
        const texto = this.$v.objGuardar.descripcion.$model || '';
        const longitud = texto.length;

        // Ajustar con base en longitud, puedes refinar esta lógica
        if (longitud < 100) {
          this.anchoDescripcion = '50%';
        } else if (longitud < 200) {
          this.anchoDescripcion = '70%';
        } else {
          this.anchoDescripcion = '90%';
        }
      });
    },


    filtroOpcionesTipoCupon(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()
      this.opcionesTipoCuponFiltro = this.opcionesTipoCupon.filter(em => {
        return em.descripcion.toLowerCase().includes(seach.toLowerCase())}
      )
      loading(false)
    },
    filtroOpcionesMotivoCupon(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()
      this.opcionesMotivoCuponFiltro = this.opcionesMotivoCupon.filter(em => {
        return em.descripcion.toLowerCase().includes(seach.toLowerCase())}
      )
      loading(false)
    },
    filtroOpcionesTipoDescuento(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()
      this.opcionesTipoDescuentoFiltro = this.opcionesTipoDescuento.filter(em => {
        return em.descripcion.toLowerCase().includes(seach.toLowerCase())}
      )
      loading(false)
    },
    filtroOpcionesTipoAplicacion(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()
      this.opcionesTipoAplicacionFiltro = this.opcionesTipoAplicacion.filter(em => {
        return em.descripcion.toLowerCase().includes(seach.toLowerCase())}
      )
      loading(false)
    },

    filtroOpcionesTipoPaciente(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()
      this.opcionesTipoPacienteFiltro = this.opcionesTipoPaciente.filter(em => {
        return em.descripcion.toLowerCase().includes(seach.toLowerCase())}
      )
      loading(false)
    },
    filtroOpcionesSubTipoPaciente(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()
      this.opcionesSubTipoPacienteFiltro = this.opcionesSubTipoPaciente.filter(em => {
        return em.descripcion.toLowerCase().includes(seach.toLowerCase())}
      )
      loading(false)
    },

    filtroOpcionesEsquemaPagoCupon(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()
      this.opcionesEsquemaPagoCuponFiltro = this.opcionesEsquemaPagoCupon.filter(em => {
        return em.nombreEsquema.toLowerCase().includes(seach.toLowerCase())}
      )
      loading(false)
    },

    limpiarCampos() {
      let existeTDC = false;

      this.objGuardar.idsFormasPago.forEach(f => {
        if (f === 2){
          existeTDC = true;
        }
      })

      if (!existeTDC){
        this.objGuardar.idsMsi = [];
      }
    },

    validateState(name) {
      const {$dirty, $error} = this.$v.objGuardar[name];
      return $dirty ? !$error : null;
    },

    selectClass(attribute) {
      let state = this.validateState(attribute)
      if (state) {
        return 'border rounded-lg border-success'
      } else if (state === false) {
        return 'border rounded-lg border-danger'
      } else {
        return ''
      }
    },

    /*Metodos de busqueda de paciente*/
    buscarPacientes() {

      if (this.validarInputBusqueda()) {
        console.error("No se puede buscar por validacion de numeros letras")
        return;
      }

      this.pacSelTmp = null;
      this.mostrarAdvertencia = false;

      if (this.loadingPacientes) {
        return;
      }

      this.registros = Array();
      this.paginaActual = 1;
      if (
          this.nombrePacienteBusqueda === undefined ||
          this.nombrePacienteBusqueda === null ||
          this.nombrePacienteBusqueda.length < 4
      ) {
        return;
      }

      const inputTxt = this.nombrePacienteBusqueda
          .trim()
          .toUpperCase();

      this.loadingPacientes = true;
      const parametros = {datoBuscar: inputTxt}
      this.$http
          .post(
              this.$api +
              "paciente/perfiles/buscarPacienteMin", parametros
          )
          .then((response) => {
            if (response.status === 200) {


              if (Array.isArray(response.data.data)) {
                this.registros = response.data.data;

                this.registros.forEach(e => {
                  e.color = e.idTipoPaciente==1?'white':'#00aa33'
                });

                if (Array.isArray(this.registros)) {
                  this.registros.sort(function (a, b) {
                    if (a.id > b.id) {
                      return 1;
                    }
                    if (a.id < b.id) {
                      return -1;
                    }
                    return 0;
                  });
                }
              }
            }
          })
          .catch((error) => {
            miniToastr.info("No se encontraron pacientes");
            console.error("Error", error);
            this.loadingPacientes = false;
          })
          .finally(() => {
            this.loadingPacientes = false;
          });
    },
    async seleccionarPaciente(item) {

      this.pacSelTmp = item;


      if (this.datosCita !== undefined && this.datosCita !== null
          && this.datosCita.idPaciente !== undefined && this.datosCita.idPaciente !== null ) {

        this.$swal.fire({
          icon: "warning",
          html: '<strong  style="font-size:14px;"><span>Cambiar paciente eliminará la información actual</span></strong> <br>' +
              ' <br> <h5 style="font-size: 12px;margin-bottom: -20px;"> Si cambia de paciente, perderá la información </h5> ' +
              '<br> <h5 style="font-size: 12px;">ingresada, ¿Desea continuar?</h5>',
          confirmButtonText: "Continuar",
          confirmButtonColor: '#1b81af',
          cancelButtonText: "Cancelar",
          showLoaderOnConfirm: true,
          showCancelButton: true,
          closeOnClickOutside: false,
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            this.submitSelPaciente();
          }
        })

        this.mostrarAdvertencia = true;
        return;
      }else {
        this.submitSelPaciente();
      }


    },
    submitSelPaciente () {
      this.mostrarBarraBusqueda = false;
      this.nombrePacienteBusqueda = null;
      this.registros = null;
      this.pacienteSeleccionado = true;
      window.scrollTo(0, 0);

      this.datosCita = new DatosCita();
      this.datosCita.idPaciente = this.pacSelTmp.id;
      this.datosCita.nombrePaciente = this.pacSelTmp.nombre;
      this.datosCita.esPacienteNuevo = this.pacSelTmp.idTipoPaciente == 1;
      this.datosCita.idTipoPaciente = this.pacSelTmp.idTipoPaciente;
      this.datosCita.tipoPaciente = this.pacSelTmp.tipoPaciente;
      this.datosCita.idSexo = this.pacSelTmp.idSexo;
      this.datosCita.celular = this.pacSelTmp.telefono;
      this.datosCita.correo = this.pacSelTmp.correo;
      this.objGuardar.correo = this.pacSelTmp.correo;
      this.datosCita.ptiActivo = this.pacSelTmp.ptiActivo;
      this.datosCita.fechaNacimientoCompleta = this.pacSelTmp.fechaNacimientoCompleta;
      this.datosCita.confianza = this.pacSelTmp.confianza;
      this.datosCita.ultimoTratamiento = this.pacSelTmp.ultimoTratamiento;
      this.datosCita.fechaUltimoTratamiento = this.pacSelTmp.fechaUltimoTratamiento;

      this.datosCita.ultTrataDesde = this.$formatoFechaHace(this.$moment(this.datosCita.fechaUltimoTratamiento));

      this.datosCita.idTagMotivoCita = null;
      this.datosCita.idTratamiento = null;

      this.$emit('seleccionarPaciente', this.datosCita);

      this.mostrarAdvertencia = false;

      window.scrollTo(0,0)

    },
    async reabrirBusquedaPaciente() {
      this.registros = null;
      this.nombrePacienteBusqueda = null;
      // this.mostrarBarraBusqueda = true;
      this.mostrarBarraBusqueda = !this.mostrarBarraBusqueda;
    },
    async eliminarPaciente() {
      this.datosCita = null;
      this.objGuardar.enviarCorreo = false;
      this.mostrarBarraBusqueda = true;
    },
    validarInputBusqueda() {
      if (this.nombrePacienteBusqueda !== undefined
          && this.nombrePacienteBusqueda !== null
          && this.nombrePacienteBusqueda !== '') {

        const contieneNumerosLetras =  /[A-Za-z]/.test(this.nombrePacienteBusqueda);
        const contieneNumeros = /[0-9]/.test(this.nombrePacienteBusqueda);
        return contieneNumerosLetras && contieneNumeros;
      }

      return false;
    },



    cargarCatalogos() {
      this.opcionesTipoCupon = [];
      this.opcionesMotivoCupon = [];
      this.opcionesTipoDescuento = [];
      this.opcionesTipoAplicacion= [];
      this.opcionesTipoEstatusCupon = [];
      this.opcionesTipoPaciente = [];
      this.opcionesSubTipoPaciente = [];
      this.opcionesEsquemaPagoCupon = [];
      this.opcionesFormaPago = [];
      this.opcionesMeses = [];

      this.$http.get(this.$api + "catalogos/obtenerTiposCupones").then(response => {
        if (response.data.data) {
          this.opcionesTipoCupon = response.data.data
          this.opcionesTipoCuponFiltro = this.opcionesTipoCupon;
        }
      });

      this.$http.get(this.$api + "catalogos/obtenerMotivoCupon").then(response => {
        if (response.data.data) {
          this.opcionesMotivoCupon = response.data.data
          this.opcionesMotivoCuponFiltro = this.opcionesMotivoCupon;
        }
      });

      this.$http.get(this.$api + "catalogos/obtenerTiposDescuentos").then(response => {
        if (response.data.data) {
          this.opcionesTipoDescuento = response.data.data
          this.opcionesTipoDescuentoFiltro = this.opcionesTipoDescuento;
        }
      });

      this.$http.get(this.$api + "catalogos/obtenerTipoAplicacionDescuento").then(response => {
        if (response.data.data) {
          this.opcionesTipoAplicacion = response.data.data
          this.opcionesTipoAplicacionFiltro = this.opcionesTipoAplicacion;
        }
      });


      this.$http.get(this.$api + "catalogos/tipoPaciente").then(response => {
        if (response.data.data) {
          this.opcionesTipoPaciente = response.data.data
          this.opcionesTipoPacienteFiltro = this.opcionesTipoPaciente;
          this.opcionesTipoPacienteFiltro.unshift({idTipoPaciente: 0, descripcion: 'Todos'})

          if (this.objGuardar.idTipoPaciente === null && !this.mostrarGuardar) {
            this.objGuardar.idTipoPaciente = 0;
          }
        }
      });

      this.$http.get(this.$api + "catalogos/subTipoPaciente").then(response => {
        if (response.data.data) {
          this.opcionesSubTipoPaciente = response.data.data
          this.opcionesSubTipoPacienteFiltro = this.opcionesSubTipoPaciente;
          this.opcionesSubTipoPacienteFiltro.unshift({idSubTipoPaciente: 0, descripcion: 'Todos'})

          if (this.objGuardar.idSubTipoPaciente === null && !this.mostrarGuardar) {
            this.objGuardar.idSubTipoPaciente = 0;
          }
        }
      });

      this.$http.get(this.$api + "catalogos/obtenerEsquemaPagoCupon").then(response => {
        if (response.data.data) {
          this.opcionesEsquemaPagoCupon = response.data.data
          this.opcionesEsquemaPagoCuponFiltro = this.opcionesEsquemaPagoCupon;
        }
      });

      this.$http.get(this.$api + "catalogos/listaFormas").then(response => {
        if (response.data.data) {
          this.opcionesFormaPago = response.data.data
          this.opcionesFormaPago.forEach(fp=>{
            fp.isOpen = false;
          });
        }
      });

      this.$http.get(this.$api + "financiera/obtener").then((respuesta) => {
        if (respuesta.data.data) {
          this.opcionesFinancieras = respuesta.data.data;
        }
      });

      this.$http.get(this.$api + "forma/obtener/detallesFormaPagoCupon").then(response => {
        if (response.data.data) {
          this.opcionesMeses = response.data.data
          this.opcionesMesesFiltro = this.opcionesMeses;
        }
      });

    },

    catalogos() {
      this.obtenerClinicas();
      this.obtenerTratamientos();
      this.obtenerTipodePromocion();
      this.obtenerZonas();
      this.obtenerEspecialidades();
    },

    obtenerClinicas() {
      this.$options.catalogosService.listaClinicas().then((response) => {
        this.clinicas = response;
      });
    },
    obtenerTratamientos() {
      this.$options.catalogosService
          .obtenerTratamientosConEspecilidades()
          .then((response) => {
            this.tratameintos = response;
          });
    },
    obtenerTipodePromocion() {
      this.$options.catalogosService.listaTiposPromocion().then((response) => {
        this.tipos = response;
      });
    },

    filtrarTabInvalido() {
      if (this.$v.objGuardar.idTipoCupon.$invalid ||
          this.$v.objGuardar.codigo.$invalid ||
          this.$v.objGuardar.descripcion.$invalid ||
          this.$v.objGuardar.idMotivoCupon.$invalid ||
          this.$v.objGuardar.idTipoDescuentoCupon.$invalid ||
          this.$v.objGuardar.idTipoAplicacion.$invalid ||
          this.$v.objGuardar.cantidadDescuento.$invalid ||
          this.$v.objGuardar.numeroRedenciones.$invalid ||
          this.$v.objGuardar.fechaExpiracion.$invalid ||
          this.$v.objGuardar.idTipoPaciente.$invalid ||
          this.$v.objGuardar.idSubTipoPaciente.$invalid)
      {
        this.tab1Vacio = true;
      }

      if (this.objGuardar.idTipoAplicacion===2 &&  this.objGuardar.tratamientos.length === 0) {
        this.tab2Vacio = true;
      }

    },
    guardar() {
      if (this.objGuardar.idCupon === null && this.objGuardar.idMotivoCupon === 2 && (this.objGuardar.enviarCorreo != null && this.objGuardar.enviarCorreo) && !this.$emailState(this.objGuardar.correo)) {
        Swal.fire("Aviso", "Por favor ingresa un correo válido", "info");
        return;
      }
      if (this.objGuardar.descripcion.length >= 255 ) {
        Swal.fire("Aviso", "La descripción no puede ser tan larga", "info");
        return;
      }

      if (this.objGuardar.idTipoCupon === 2 && this.datosCita === null) {
        return;
      } else if (this.objGuardar.idTipoCupon === 2 && this.datosCita !== null) {
        this.objGuardar.idPaciente = this.datosCita.idPaciente;
      }

      this.$v.objGuardar.$touch();
      if (this.$v.objGuardar.$anyError) {
        return;
      }
      if(this.objGuardar.idTipoAplicacion === 2 ){
        let tratamientos = this.$refs.formularioTratamientos.tratamientos;
        this.$set(this.objGuardar, "tratamientos", tratamientos)

        if (this.objGuardar.idTipoDescuentoCupon === 1 && this.objGuardar.tratamientos.length !== 0) {
          let existeValidacionInvalida = this.objGuardar.tratamientos.some(tx =>
              !(tx.cantidadDescuento > 0 && tx.cantidadDescuento <= 99) || tx.cantidadDescuento === null)

          if (existeValidacionInvalida) {
            this.tab2Vacio = true;
            return;
          }
        } else if (this.objGuardar.idTipoDescuentoCupon === 2 && this.objGuardar.tratamientos.length !== 0) {
          let existeValidacionInvalida = this.objGuardar.tratamientos.some(tx =>
              tx.cantidadDescuento === null || tx.cantidadDescuento === '' || tx.cantidadDescuento < 1)

          if (existeValidacionInvalida) {
            this.tab2Vacio = true;
            return;
          }
        }
      }
      this.tab1Vacio = false;
      this.tab2Vacio = false;


      if (this.objGuardar.idTipoAplicacion===2 && this.objGuardar.tratamientos.length === 0) {
        this.filtrarTabInvalido();
        return;
      }

      if (this.objGuardar.idTipoAplicacion === 1 && this.objGuardar.idEsquemaPagoCupon === null && this.objGuardar.idMotivoCupon === 3) {
        return;
      }

      if (this.objGuardar.idMotivoCupon === 3 && this.objGuardar.idsFormasPago.length < 1) {
        return;
      }
      if (this.objGuardar.maxCompra < this.objGuardar.minCompra){
        this.$swal({
          icon: "warning",
          text: "El monto máximo de compra no puede ser menor al monto mínimo de compra",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });
        this.objGuardar.maxCompra = null;
        return;
      }

      if (this.$v.objGuardar.fechaExpiracion.$invalid) {
        return;
      }

      if(this.objGuardar.enviarCorreo == null){
        this.objGuardar.enviarCorreo = false;
      }

      this.objGuardar.opcionGuardar = 1;
      this.loading = true;

      this.$http
          .post(this.$api + "cupon/guardarCupon", this.objGuardar)
          .then((response) => {
            if (response.status === 200) {
              this.$swal.fire({
                position: "center",
                icon: response.data.data != null ? "success" : "info",
                title: "Aviso",
                text: response.data.data != null ? "Cupón registrado correctamente" : response.data.message,
                showConfirmButton: false,
                timer: 3500,
              });
              if (response.data.data != null){
                this.$emit("actualizar", this.objGuardar.codigo);
                this.limpiarDatos();
              }

              this.$nextTick(() => {
                this.$v.$reset()
              });
            }
          }).catch((error)=>{
        console.error(error);
        this.$swal.fire({
          position: "center",
          icon: "error",
          title: "Ocurrio un error al registrar el cupón",
          showConfirmButton: false,
          timer: 3500,
        });
      }).finally(() => {
        this.loading = false;
      });
    },


    agregarTratamientoPromocion(e) {
      const tipoPromo = this.promocion.idTipoPromocion
      if(tipoPromo == 2 && this.promocion.tratamientos.length <= 0 || tipoPromo == 3 && this.promocion.tratamientos.length <= 0) {
        this.$swal.fire({
          icon: "warning",
          title: "Aviso",
          text: "Debe seleccionar un tratamiento base",
        });
      }else {
        if (!this.promocion.txPromocion.includes(e)) {
          e.zonas = this.zonas.map((z) => {
            z.descuento = 0;
            if (this.promocion.idTipoPromocion === 2) {
              z.descuento = 100;
            }
            return JSON.parse(JSON.stringify(z));
          });

          this.promocion.txPromocion.push(e);
        }
      }


    },
    agregarTratamiento(e) {
      if (
          this.promocion.idTipoPromocion === 1 ||
          this.promocion.idTipoPromocion === 4
      ) {
        this.agregarTratamientoPromocion(e);
      } else {
        if (!this.promocion.tratamientos.includes(e)) {
          this.promocion.tratamientos.push(e);
        }
      }
    },
    eliminarTratamiento(e) {
      if (this.promocion.tratamientos.length == 1){
        this.eliminarMuchosTratamientos(e);
      }
      this.promocion.tratamientos.splice(
          this.promocion.tratamientos.indexOf(e),
          1
      );

    },
    eliminarMuchosTratamientos() {
      this.promocion.txPromocion.splice(this.promocion.txPromocion);
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      }
    },
    limpiarDatos() {
      this.objGuardar = {
        codigo:null,
        descripcion:null,
        idTipoDescuentoCupon: null,
        idTipoCupon: null,
        idTipoAplicacion:null,
        numeroRedenciones: null,
        cantidadDescuento: null,
        idEstatusCupon: 1,
        fechaExpedicion: null,
        fechaExpiracion: null,
        idTipoPaciente: null,
        idSubTipoPaciente: null,
        otraPromo: false,
        tratamientos: []
      }
    },
    tipoDeAplicacion(e) {
      if (e !== null) {
        if (e === 1) {
          this.bloquearEsquemaPago = false;
        } else if (e === 2 && !this.mostrarGuardar) {
          this.bloquearEsquemaPago = true;
        } else if (e === 2 && this.mostrarGuardar) {
          this.bloquearEsquemaPago = true;
          this.objGuardar.min = 0;
          this.objGuardar.max = 0;
        }
      }
    },
    cantidadMinMax(val) {
      let valor = Number(val)
      if (this.objGuardar.idMotivoCupon === 3 && this.objGuardar.idTipoDescuentoCupon === 2) {
        this.objGuardar.minCompra = valor + 1;
        this.cantidadMinCompra = valor + 1;
      } else if (this.objGuardar.idMotivoCupon === 3){
        this.objGuardar.minCompra = 1;
        this.cantidadMinCompra = 1;
      } else {
        this.objGuardar.minCompra = 0;
        this.cantidadMinCompra = 0;
      }
    },
    esConpensacion(val) {
      if (val === 2) {
        this.objGuardar.idTipoCupon = 2;
        this.siEsCompensacion = true
        this.objGuardar.numeroRedenciones = 1
        this.limpiarAtributosPacienteYRestriCompra();
      } else if (val === 3 && this.mostrarGuardar) {
        this.objGuardar.idTipoCupon = null
        this.siEsCompensacion = false
      } else if(val === 1){
        this.objGuardar.idTipoCupon = 1;
        this.siEsCompensacion = true
        this.limpiarAtributosPacienteYRestriCompra();
      }
    },
    limpiarAtributosPacienteYRestriCompra() {
      this.objGuardar.idSubTipoPaciente = null
      this.objGuardar.idTipoPaciente = null
      this.objGuardar.minCompra = 0
      this.objGuardar.maxCompra = 0
      this.objGuardar.idEsquemaPagoCupon = null
      this.objGuardar.idsFormasPago = []
      this.objGuardar.idsMsi = []
    }
  },
}
;
</script>

<style scoped>
.letter{
  font-size: 11px;
}

.redondeo{
  border-radius: 10px !important;
  font-size: 12px;
}


b-form-checkbox[class="blue"] + span::before
{
  border: solid 1px blue;
  background: #B2DBFF;
  background: -moz-radial-gradient(#B2DBFF, #dfdfdf);
  background: -webkit-radial-gradient(#B2DBFF, #dfdfdf);
  background: -ms-radial-gradient(#B2DBFF, #dfdfdf);
  background: -o-radial-gradient(#B2DBFF, #dfdfdf);
  background: radial-gradient(#B2DBFF, #dfdfdf);
}


.scrollPorTabs {
  height:51vh;
  overflow-y: scroll;
  overflow-x: hidden
}
.txSesion>.card-body {
  font-size: small !important;
  padding: 0.5rem !important;
}
.button-dentalia-svg-1 {
  border-radius: 50rem !important;
  color: #fff;
  background-color: var(--color-dentalia-v2);
  border-color: var(--color-dentalia-v2);
  margin-left: 5%;
  padding: 5px;
}
</style>
